const headRowsGroup = {
  actions: 'Ações',
  name: 'Grupo'
};

export default headRowsGroup;
